<template>
  <div
    class="dashboard_admin"
    :class="{ 'home-screen-content': $route.query.islscreen }"
  >
    <!-- dashboard_admin-topfixed -->
    <div
      class="header-top dashboard_admin-topfixed"
      v-if="!$route.query.islscreen"
    >
      <!-- <span>{{$t("dashboard.admin.ESLRealTimeMonitoringPlatform")}}</span> -->
      <!-- <span class="time">{{ timer }}</span> -->
      <span class="screenful" @click="handelLargeScreen">{{ $t("dashboard.Large screen") }}</span>
    </div>

    <div class="header-top dashboard_admin-top screen-card-bg" v-else>
      <img src="@/assets/img/wintec.png"
        style="height: 25px"
      />
      <span class="time"><time-control /></span>
      <Screenfull />
    </div>

    <div
      :class="{
        'content-is-not-lscreen': $route.query.islscreen,
        'content-is-lscreen': !$route.query.islscreen,
      }"
    >
      <el-row
        :gutter="32"
        class="width_100"
        style="margin-right: 0; margin-left: 0"
      >
        <el-col
          :md="24"
          :lg="12"
          :xl="8"
          class="paddinng_l0 margin_b20"
          :style="{ paddingRight: screenWidth < 1188 ? 0 : '20px' }"
        >
          <esl-update-today-card
            :total="ESLUpdateTodayData.tagTotal"
          ></esl-update-today-card>
          <el-row class="margin_t16 flex-between">
            <el-col :span="12" style="padding-right: 16px">
              <pie-card :options="updateSourceOptions"></pie-card>
            </el-col>
            <el-col :span="12" class="paddinng_l0 paddinng_r0">
              <pie-card :options="linkedTodayOptions"></pie-card>
            </el-col>
          </el-row>
        </el-col>
        <el-col
          :md="24"
          :lg="12"
          :xl="8"
          class="paddinng_l0 paddinng_r0 margin_b20"
        >
          <!-- <div class="dashboard-card"> -->
          <statistics-card :options="statisticOptions"></statistics-card>
          <!-- </div> -->
        </el-col>

        <el-col
          :md="24"
          :lg="24"
          :xl="8"
          class="paddinng_r0 margin_b20"
          :style="{ paddingLeft: screenWidth < 1900 ? 0 : '20px' }"
        >
          <store-exceptionType-statistics
            :options="storeExceptionTypeStatisticsList"
          ></store-exceptionType-statistics>
        </el-col>
      </el-row>
      <el-row
        :gutter="32"
        class="width_100"
        style="margin-right: 0; margin-left: 0"
      >
        <el-col
          :md="24"
          :xl="16"
          class="paddinng_l0 paddinng_r0 margin_b20"
          :style="{ paddingRight: screenWidth < 1188 ? 0 : '20px' }"
        >
          <div class="dashboard-card screen-card-bg">
            <span class="title">{{
              $t("dashboard.admin.UpdateRealTimeStatisticsToday")
            }}</span>
            <curve-line-chart
              :chartData="hourEslData"
              :isLScreenStyle="isLScreenStyle"
            ></curve-line-chart>
          </div>
        </el-col>
        <el-col
          :md="24"
          :xl="8"
          class="paddinng_r0 margin_b20"
          :style="{
            paddingLeft: screenWidth < 1900 ? 0 : '20px',
          }"
        >
          <div class="dashboard-card screen-card-bg">
            <span class="title">{{
              $t("dashboard.admin.StoreExceptionlist")
            }}</span>
            <store-exception-table
              @updateTableList="updateTableList"
              :tableData="tableData"
            ></store-exception-table>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="32" style="margin-right: 0; margin-left: 0">
        <el-col :md="24" :lg="8" class="paddinng_r0 paddinng_l0">
          <div class="dashboard-card margin_b20 screen-card-bg">
            <span class="title">
              {{ $t("dashboard.admin.ESLUpdatedQuantity") }}
              {{ $t("dashboard.admin.(TOP 5)") }}
            </span>
            <bar-grid-vertical-chart
              :isLScreenStyle="isLScreenStyle"
              :options="ESLUpdatedQuantityData"
              :title="$t('dashboard.admin.ESLUpdatedQuantity')"
            ></bar-grid-vertical-chart>
          </div>
        </el-col>
        <el-col
          :md="24"
          :lg="8"
          :style="{
            paddingLeft: screenWidth < 1188 ? 0 : '20px',
            paddingRight: 0,
          }"
        >
          <div class="dashboard-card margin_b20 screen-card-bg">
            <span class="title">
              {{ $t("dashboard.admin.ESLUpdateFailed") }}
              {{ $t("dashboard.admin.(TOP 5)") }}
            </span>
            <bar-grid-vertical-chart
              :isLScreenStyle="isLScreenStyle"
              :options="ESLUpdateFailedData"
              :title="$t('dashboard.admin.ESLUpdateFailed')"
            ></bar-grid-vertical-chart>
          </div>
        </el-col>
        <el-col
          :md="24"
          :lg="8"
          :style="{
            paddingLeft: screenWidth < 1188 ? 0 : '20px',
            paddingRight: 0,
          }"
        >
          <div class="dashboard-card margin_b20 screen-card-bg">
            <span class="title">
              {{ $t("dashboard.admin.ESLOnline") }}
              {{ $t("dashboard.admin.(TOP 5)") }}
            </span>
            <bar-grid-vertical-chart
              :isLScreenStyle="isLScreenStyle"
              :options="ESLOnlinedData"
              :title="$t('dashboard.admin.ESLOnline')"
            ></bar-grid-vertical-chart>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
// Admin
import EslUpdateTodayCard from "../components/EslUpdateTodayCard.vue";
import PieCard from "../components/PieCard.vue";
import StatisticsCard from "../components/StatisticsCard.vue";
import StoreExceptionTypeStatistics from "../components/StoreExceptionTypeStatistics.vue";
import TimeControl from "./Time.vue";

import {
  countHourEsl,
  countEsl,
  getTop,
  countExStat,
  countStat,
  countExDetail
} from "@/libs/api/dashboard";
import BarGridVerticalChart from "../echarts/BarGridVerticalChart.vue";
import CurveLineChart from "../echarts/CurveLineChart.vue";
import StoreExceptionTable from "../components/StoreExceptionTable.vue";
import Screenfull from "@/components/Screenfull";
import moment from "moment";
export default {
  components: {
    EslUpdateTodayCard,
    PieCard,
    StatisticsCard,
    BarGridVerticalChart,
    StoreExceptionTypeStatistics,
    CurveLineChart,
    StoreExceptionTable,
    Screenfull,
    TimeControl,
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      ESLUpdateTodayData: {},
      updateSourceOptions: {},
      linkedTodayOptions: {},
      statisticOptions: {
        statisticList: [],
        statisticListB: [],
      },
      storeExceptionTypeStatisticsList: {
        dataList: [],
        maxNum: [],
      },
      tableData: [],

      isLScreenStyle: {
        //大屏  颜色
        xAxisColor: "rgba(255, 255, 255, .6)",
        yAxisColor: "rgba(255, 255, 255, .6)",
        gridlinesColor: "rgba(48, 55, 78, 1)",
      },

      ESLUpdatedQuantityData: {
        columnColor: "rgba(78, 145, 255, 1)",
        XData: [],
        valueData: [],
      },
      ESLUpdateFailedData: {
        columnColor: "rgba(231, 14, 57, 1)",
        XData: [],
        valueData: [],
      },
      ESLOnlinedData: {
        columnColor: "rgba(157, 142, 243, 1)",
        XData: [],
        valueData: [],
      },

      countEslUpdatedStaticData: {},
      countApData: {},
      countUpdateEslData: {},
      countUpdateSourceData: {},
      hourEslData: {
        xData: [],
        yData: [],
      },
      timer: "",
    };
  },
  props: {
    timeFormat: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss'
    }
  },
  created() {
    setInterval(() => {
      this.timer = moment(new Date().getTime()).format(this.timeFormat);
    }, 100);
    this.initeData();
  },
  mounted() {
    window.addEventListener("resize", this.watchWindowSize);
  },
  computed: {},
  methods: {
    watchWindowSize() {
      this.screenWidth = document.documentElement.clientWidth;
    },
    initeData() {
      this.countHourEsl();
      this.countEsl();
      this.getTop();
      this.countExStat();
      this.countStat();
      this.countExDetail();
    },
    handelLargeScreen() {
      let path = this.$router.resolve({
        path: "/dashboard/lscreen",
        query: {
          islscreen: true,
        },
      });
      window.open(path.href, "_blank");
    },
    async countHourEsl() {
      try {
        const { data } = await countHourEsl();
        if (data.state === true) {
          let datalist = data.data || [];
          let xData = [];
          let yData = [];
          if (datalist && datalist.length) {
            datalist.forEach((item) => {
              xData.push(item.hour);
              yData.push(item.total);
            });
          }

          this.hourEslData.xData = xData;
          this.hourEslData.yData = yData;
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },
    async countEsl() {
      try {
        const { data } = await countEsl();
        if (data.state === true) {
          let dataNew = data.data || {};

          // 今日绑定
          let linkedTodayOptions = {
            chartData: [
              {
                name: this.$t("dashboard.admin.Linked"),
                value: dataNew["linkNumber"],
                customColor: "157, 142, 243",
                icon: "bz-linked",
              },
              {
                name: this.$t("dashboard.admin.Unlinked"),
                value: dataNew["unlinkNumber"],
                customColor: "254, 102, 132",
                icon: "bz-unlinked",
              },
            ],
            title: this.$t("dashboard.admin.Linked Today"),
            colors: ["#9D8EF3", "#FE6684"],
          };
          this.linkedTodayOptions = linkedTodayOptions;
          // 更新来源
          let updateSourceOptions = {
            chartData: [
              {
                name: this.$t("dashboard.admin.System"),
                value: dataNew["systemTagNumber"],
                customColor: "0, 192, 255",
                icon: "bz-system-blue",
              },
              {
                name: this.$t("dashboard.admin.PDA"),
                value: dataNew["pdaTagNumber"],
                customColor: "253, 190, 0",
                icon: "bz-pda",
              },
            ],
            colors: ["#00C0FF", "#FDBE00"],
            title: this.$t("dashboard.admin.Update Source"),
          };
          this.updateSourceOptions = updateSourceOptions;
          this.ESLUpdateTodayData.tagTotal = dataNew["tagTotal"];
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },
    async countExStat() {
      try {
        const { data } = await countExStat();
        if (data.state === true) {
          let dataNew = data.data || {};
          let dataList = [
            {
              name: this.$t("dashboard.admin.Total"),
              number: dataNew["total"],
              color: "#E70E39",
            },
            {
              name: this.$t("dashboard.admin.ESL Exception"),
              number: dataNew["tagExNum"],
              color: "#FDBE00",
            },
            {
              name: this.$t("dashboard.admin.Interface Exception"),
              number: dataNew["interfaceExNum"],
              color: "#4E91FF",
            },
            {
              name: this.$t("dashboard.admin.APs Exception"),
              number: dataNew["apExNum"],
              color: "#8F7FEB",
            },
          ];

          dataList.sort((a, b) => {
            return b.number - a.number;
          });
          this.storeExceptionTypeStatisticsList.dataList = dataList;
          this.storeExceptionTypeStatisticsList.maxNum = dataNew["total"] || 0;
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },
    async countStat() {
      try {
        const { data } = await countStat();
        if (data.state === true) {
          let dataNew = data.data || {};
          let statisticOptionsTop = [
            {
              name: this.$t("dashboard.admin.Total Distributor"),
              val: dataNew.agentNum,
              customColor: "78, 145, 255",
            },
            {
              name: this.$t("dashboard.admin.Total Customer"),
              val: dataNew.merchantNum,
              customColor: "26, 205, 172",
            },
            {
              name: this.$t("dashboard.admin.Total Store"),
              val: dataNew.storeNum,
              customColor: "85, 105, 236",
            },
            {
              name: this.$t("dashboard.admin.Total ESLs"),
              val: dataNew.tagNum,
              customColor: "26, 205, 172",
            },
          ];
          let statisticOptionsBottom = [
            {
              name: this.$t("dashboard.admin.ESL Linked"),
              val: dataNew.bindTagNum,
              customColor: "254, 102, 132",
            },
            {
              name: this.$t("dashboard.admin.Total Items"),
              val: dataNew.itemNum,
              customColor: "157, 142, 243",
            },
            {
              name: this.$t("dashboard.admin.Total Bind Items"),
              val: dataNew.bindItemNum,
              customColor: "253, 190, 0",
            },
            {
              name: this.$t("dashboard.admin.Total APs"),
              val: dataNew.apNum,
              customColor: "0, 192, 255",
            },
          ];
          this.statisticOptions.statisticList = statisticOptionsTop;
          this.statisticOptions.statisticListB = statisticOptionsBottom;
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },
    async countExDetail() {
      try {
        const { data } = await countExDetail();
        if (data.state === true) {
          let datalist = data.data || [];
          this.tableData = datalist;
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },
    

    async getTop() {
      try {
        const { data } = await getTop();
        if (data.state === true) {
          let dataNew = data.data || {};
          let { countList, failList, onlineList } = dataNew;

          this.ESLUpdatedQuantityData = Object.assign(
            {},
            this.ESLUpdatedQuantityData,
            dealArrayData(countList)
          );
          this.ESLUpdateFailedData = Object.assign(
            {},
            this.ESLUpdateFailedData,
            dealArrayData(failList)
          );
          this.ESLOnlinedData = Object.assign(
            {},
            this.ESLOnlinedData,
            dealArrayData(onlineList)
          );
          function dealArrayData(data) {
            let XData = [];
            let valueData = [];
            if (data && data.length) {
              data.forEach((item) => {
                XData.push(item.customerName);
                valueData.push(item.total);
              });
            }
            return {
              XData,
              valueData,
            };
          }
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },
    updateTableList() {
      // this.getTableList()
    },
  },
};
</script>
<style lang="scss" scoped>
.dashboard_admin {
  .height_380 {
    height: 388px;
  }
  .paddinng_r0 {
    padding-right: 0 !important;
  }
  .paddinng_l0 {
    padding-left: 0 !important;
  }
  .dashboard-card {
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    padding: 20px 30px;
    .title {
      // font-size: 20px;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      display: inline-block;
      margin-bottom: 20px;
    }
  }
  .margin_t65 {
    margin-top: 65px;
  }
  .margin_t16 {
    margin-top: 20px;
  }
  .margin_t20 {
    margin-top: 20px;
  }
  .margin_b20 {
    margin-bottom: 20px;
  }
  .margin_r16 {
    margin-right: 20px;
  }
  .flex-between {
    display: flex;
    justify-content: space-between;
  }
  .width_100 {
    width: 100%;
  }
  .header-top {
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    background: #ffffff;
    height: 80px;
    line-height: 80px;
    width: 100%;
    padding: 0 30px;
    .time {
      font-size: 18px;
    }
  }
  &-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &-topfixed {
    text-align: center;
    // position: fixed;
    // top: 62px;
    // left: 0;
    // z-index: 2;
    .screenful {
      float: right;
      font-size: 18px;
      cursor: pointer;
    }
  }
  .content-is-lscreen {
    // margin-top: 85px;
    margin-top: 20px;
  }
  .content-is-not-lscreen {
    margin-top: 20px;
    padding: 0 20px 0;
  }
}
</style>

